export class TransactionStatusDescriptionValueConverter {
    toView(value: number): string {
        switch(value) {
            case 0:
                return "This transaction was created on a kiosk, but has not yet synchronized to a client application.";
            case 1:
                return "This transaction was synchronized from a kiosk or created directly on a client application.";
            case 2:
                return "This transaction was synchronized to a server, but has not yet been submitted for payment processing and/or its processing result is not yet unknown.";
            case 3:
                return "This transaction was processed successfully.";
            case 4:
                return "This transaction was submitted to the payment processor, but the payment was declined.";
            case 5:
                return "This transaction could not be processed, due to incomplete data or an error with the transaction processor.";
            case 6:
                return "This transaction was previously-processed and subsequently refunded successfully.";
            case 7:
                return "This transaction was previously-processed, but a subsequent refund attempt failed.";
            case 8:
                return "This transaction was administratively removed.";
            case 9:
                return "This transaction is pending.";
            case 10:
                return "This transaction was previously-processed and subsequently partially refunded successfully.";
            case 11:
                return "This transaction encountered an error while being processed.";
            case 12:
                return "A transaction that was collected offline (e.g. cash or check) and should not be resubmitted for online processing.";
            default:
                return "";
        }
    }
}
